<template>
  <!-- A layout item, not a block above the app: Vuetify moves the app bar, the drawer and v-main's
       padding down by its height. Pages without v-main (login, billing, plans, the popout, 404) pad
       themselves with --lew-deployment-banner-height. -->
  <v-system-bar v-if="kind" :height="height" class="deployment-banner sentry-unmask">
    <v-icon icon="mdi-hard-hat" size="18" class="deployment-banner__icon" />
    <span class="deployment-banner__kind">{{ $t(`general.deployment.${kind}`) }}</span>
    <v-icon icon="mdi-hard-hat" size="18" class="deployment-banner__icon" />
  </v-system-bar>
</template>

<script>
import { onMounted, onUnmounted } from "vue"
import { DEPLOYMENT_KIND, markFavicon } from "@/services/deployment"

const HEIGHT = 36
const HEIGHT_VAR = "--lew-deployment-banner-height"

export default {
  name: "LewDeploymentBanner",
  setup() {
    const kind = DEPLOYMENT_KIND

    if (kind) {
      onMounted(() => {
        document.documentElement.style.setProperty(HEIGHT_VAR, `${HEIGHT}px`)
        markFavicon()
      })
      onUnmounted(() => document.documentElement.style.removeProperty(HEIGHT_VAR))
    }

    return { kind, height: HEIGHT }
  },
}
</script>

<style scoped>
/* The light theme's `accent` gold, which is reserved for occasional emphasis, under faint
   construction-tape stripes: still a building site. Fixed rather than the theme variable so it looks
   the same in both themes, with the navy of the light app bar for the ink. The name sits in the
   middle between two hard hats. */
.deployment-banner {
  justify-content: center;
  gap: 10px;
  padding-inline: 16px;
  background: repeating-linear-gradient(-45deg, rgba(255, 255, 255, 0.16) 0 14px, transparent 14px 28px), #e0a458;
  color: #1b2f4e;
  font-size: 0.875rem;
}

/* VSystemBar dims its icons to medium emphasis; this one belongs to the name. */
.deployment-banner__icon {
  opacity: 1 !important;
}

.deployment-banner__kind {
  font-weight: 700;
  letter-spacing: 0.02em;
}
</style>
